import { CALL_API } from '../../../middleware/api';
import * as types from '../../../actions/types';
export const getNotifications = (page, spaceId) => {
    const paging = page ? `&page=${page}` : '';
    return {
        [CALL_API]: {
            endpoint: `/notifications?&perPage=40${paging}${spaceId ? `&spaceId=${spaceId}` : ''}`,
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            types: [
                types.GET_NOTIFICATIONS_REQUEST,
                types.GET_NOTIFICATIONS_SUCCESS,
                types.GET_NOTIFICATIONS_FAILURE,
            ],
            extra: {
                spaceId,
            },
        },
    };
};
export const resetExternalUnreadNotifications = (spaceId) => ({
    [CALL_API]: {
        endpoint: `/notifications/reset-external-unread-count${spaceId ? `?space=${spaceId}` : ''}`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            types.RESET_UNREAD_REQUEST,
            types.RESET_UNREAD_SUCCESS,
            types.RESET_UNREAD_FAILURE,
        ],
        muteAlert: true,
        extra: {
            spaceId,
        },
    },
});
